import React, { createContext, useContext, useState } from 'react';

const SimplifiedSportsbookContext = createContext();

export const createSimplifiedSportsbookState = () => {
  const [sportName, setSportName] = useState();
  const [isLiveTopTournaments, setIsLiveTopTournaments] = useState(false);

  return {
    isLiveTopTournaments,
    setIsLiveTopTournaments,
    setSportName,
    sportName,
  };
};

export const useSimplifiedSportsbook = () => useContext(SimplifiedSportsbookContext);

export const SimplifiedSportsbookProvider = ({ children }) => {
  const value = createSimplifiedSportsbookState();

  return (
    <SimplifiedSportsbookContext.Provider value={value}>
      {children}
    </SimplifiedSportsbookContext.Provider>
  );
};
